import React from "react"

import { default as VenueIcon} from "@assets/icons/suppliers/category/venues.svg?react";
import { default as DressesIcon} from "@assets/icons/suppliers/category/wedding-dresses.svg?react";
import { default as PhotographerIcon} from "@assets/icons/suppliers/category/photography.svg?react";
import { default as CelebrantIcon} from "@assets/icons/suppliers/category/celebrants.svg?react";
import { default as CarIcon} from "@assets/icons/suppliers/category/cars.svg?react";
import { default as HairMakeupIcon} from "@assets/icons/suppliers/category/hair-and-makeup.svg?react";

import { getAsset, getCountry } from '@helper/getConfigValues'
import LinkButton from "@ui/LinkButton"

import SUPPLIERS from '@data/components/submenu/suppliers'
import scss from './Suppliers.module.scss'


const ICONS = [
  <VenueIcon className={scss.icon} />,
  <DressesIcon className={scss.icon} />,
  <PhotographerIcon className={scss.icon} />,
  <CelebrantIcon className={scss.icon} />,
  <CarIcon className={scss.icon} />,
  <HairMakeupIcon className={scss.icon} />
]

function SuppliersDropdownMenu() {
  const countryCode = getCountry();
  const data = SUPPLIERS[countryCode]
  return <div className={scss.container}>
    <div className={scss.primary}>
      <div className="flex-grow-1">
        <div className={scss.subTitle}>Popular Categories</div>
        <div className={scss.popularLinks}>
          {data.popular_categories.map(({ title, url }, index) => (
            <a key={title} className={scss.popularLink} href={url}>
              {ICONS[index]}{title}
            </a>
          ))}
        </div>
      </div>

      <div className={scss.byLocation}>
        <div className={scss.byLocationTitle}>Find SUPPLIERS By Location</div>
        <div className={scss.linksColumn}>
          {data.locations.map(({ title, url }) => (
            <a key={title} className={scss.link} href={url}>
              {title}
            </a>
          ))}
        </div>
      </div>

      <div className={scss.exploreAllLinkContainer}>
        <LinkButton href="/wedding/" look="standard" className={scss.importantButton}>Explore All Categories</LinkButton>
      </div>
    </div>
    <div className={scss.secondary}>
      <div className={scss.secondaryItem}>
        {data.all_categories.map(({ title, items = [] }) => (
          <div key={title}>
            <div className={scss.title}>{title}</div>
            <div className={scss.linksColumn}>
              {items.map(({ title, url, target }) => (
                <a key={title} href={url} className={scss.link} target={!!target ? target : undefined}>{title}</a>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
    {countryCode == "au" && <div className={scss.promo}>
      <div className={scss.abbeyBg} style={{ backgroundImage: `url('${getAsset("backgrounds/menu-chelsea.jpg")}')` }}>
        <div className={scss.imageShadow}></div>
      </div>
      <div className={scss.promoInfo}>
        <div className={scss.promoText}>Want to save time, money and stress? Use our online supplier package builder, and team of experts, to help you design and book your key wedding suppliers. 
                The best price in one easy package. Built by us, designed by you! </div>
        <a href="/packages/" className={scss.promoLink}>Get my custom proposal <span className={scss.promoArrows}>&#10230;</span></a>
      </div>
    </div>}
  </div>
}

export default SuppliersDropdownMenu
